import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_ESTADISTICAS_VOLCADORAS } from '../../../../config/tables'

function EstadisticasVolcadorasView () {
  return (
    <MuiTable id={TABLA_ESTADISTICAS_VOLCADORAS} />
  )
}

export default EstadisticasVolcadorasView
